import React from 'react'

import SelectParentNew from "../../../select-parent-new"
import {SelectParent_RenderType} from "../../../@const"
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5"
import ControlButtonStandard from "../../../../../gd-components/buttons/control-button/control-button-standard";

type Props = {
    className?      : string
    parent          : SelectParentNew
}

export default function SelectParent_ValueSingle(props: Props) {

    const parent = props.parent

    let curValueString : string | null = parent.props.placeholder;
    let curIcon : any | null = parent.props.placeholderIcon ? <div className={Classes("selected-item-icon", parent.props.placeholderIcon)}/> : null
    let currentProjectId    : ID | null = parent.state.value

    /*const onReset = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        parent.onParentSelected(null)
    }*/

    if (currentProjectId) {
        const project = gd.session.projects.get(currentProjectId)
        curValueString = project?.name || null

        curIcon = <ProjectIconUI5 key          = "icon"
                                  className    = "selected-item-icon"
                                  projectId    = {currentProjectId}/>
    }

    if(!currentProjectId && parent.props.canBeNull && gd.spaces.projects.enabled){
        curValueString = gd.spaces.projects.title

        curIcon = <div className="selected-item-icon ii5-project"/>
    }

    switch (parent.props.renderType) {
        case SelectParent_RenderType.CIRCLE_BTN:
            const classes = Classes("cur-value", parent.props.curValueClasses, {
                'i5-portfolio': !currentProjectId
            })

            return <div className   = {classes}
                        onClick     = {parent.showPopover}>{curValueString}</div>

        case SelectParent_RenderType.FUNCTION:
            if(props.parent.props.renderValueFunc) {
                return props.parent.props.renderValueFunc(currentProjectId, parent.showPopover)
            }
            break

        // case SelectParent_RenderType.VIEW:
        //
        //     return  <React.Fragment>
        //         {this.props.showIcon && this.renderCurIcon()}
        //         {this.renderCurValue()}
        //     </React.Fragment>
        //

        case SelectParent_RenderType.INLINE_EDITABLE:

            return (
                <div className  = {Classes("cur-value w-100-percent", parent.props.curValueClasses)}
                     onClick    = {parent.showPopover}>
                     <span>
                         {curIcon}
                         {curValueString}
                         {/*{parent.props.canBeNull &&
                             <span className="m-l-5" onClick={onReset}>Reset</span>
                         }*/}
                        </span>
                </div>
            )

        case SelectParent_RenderType.GRAY_RECTANGLE:
            return (
                <div className  = {Classes("cur-value", parent.props.curValueClasses)}
                     onClick    = {parent.showPopover}>
                    {curValueString}
                    <div className="arrow-icon gd-icon-arrow-down"/>
                </div>
            )

        case SelectParent_RenderType.FORM:
            // default:

            return (
                <div className={Classes("cur-value", parent.props.curValueClasses)}
                     onClick={parent.showPopover}>
                        <span>
                            {curIcon}
                            {curValueString}
                            {/*{parent.props.canBeNull &&
                                <span className="m-l-5" onClick={onReset}>Reset</span>
                            }*/}
                        </span>

                    <div className="arrow-icon i5-big-angle-down"/>
                </div>
            )

        case SelectParent_RenderType.CONTROL_BUTTON:
            return (
                <ControlButtonStandard className    = {Classes("cur-value p-l-10 p-r-10", parent.props.curValueClasses)}
                                       onClick      = {parent.showPopover}
                                       isSelected   = {true}
                                       selectedClass= "hover-bg"
                >
                    <div className="m-r-8">
                        {curIcon}
                    </div>
                    {curValueString}
                </ControlButtonStandard>
            )
    }

    return null
}
